import mutations from './monthlyPremiumForDoctors.mutations'
import actions from './monthlyPremiumForDoctors.actions'
import getters from './monthlyPremiumForDoctors.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
